var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "myDialog",
      attrs: {
        title: "附件",
        visible: _vm.visible,
        width: "1000px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "el-row",
            {
              staticStyle: {
                "margin-top": "-36px",
                "margin-left": "-20px",
                "margin-right": "-20px",
              },
            },
            [_c("el-divider")],
            1
          ),
          _c(
            "el-tabs",
            {
              staticStyle: { "margin-top": "-15px" },
              attrs: { type: "border-card" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  staticStyle: { height: "300px" },
                  attrs: { label: "附件列表", name: "attach" },
                },
                [
                  _c(
                    "el-form",
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              attrs: {
                                action: _vm.uploadAction,
                                headers: _vm.headers,
                                "before-upload": _vm.handleBeforeUpload,
                                "http-request": _vm.handleUpload,
                                multiple: true,
                                limit: 5,
                                "auto-upload": false,
                                "on-exceed": _vm.handleExceed,
                                "before-remove": _vm.beforeRemove,
                                "on-change": _vm.handleChange,
                                "on-remove": _vm.handleChange,
                                "file-list": _vm.attachList,
                                "show-file-list": false,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { type: "primary", size: "mini" } },
                                [_vm._v("上传")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          staticStyle: { height: "260px" },
                          attrs: { data: _vm.attachList, border: "" },
                          on: { "row-dblclick": _vm.handleRowDbClick },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "序号",
                              prop: "index",
                              width: "50",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.$index + 1)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "attName",
                              label: "名称",
                              "min-width": "200px",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "attFormat",
                              label: "格式",
                              width: "80px",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "attVersion",
                              label: "*版本",
                              width: "100px",
                              "show-overflow-tooltip": true,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      model: {
                                        value: scope.row.attVersion,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "attVersion", $$v)
                                        },
                                        expression: "scope.row.attVersion",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "attSource",
                              label: "*来源",
                              width: "80px",
                              "show-overflow-tooltip": true,
                              formatter: _vm.statusFormat,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "",
                                          size: "small",
                                          disabled:
                                            _vm.attSource !== null &&
                                            _vm.attSource !== undefined,
                                        },
                                        model: {
                                          value: scope.row.attSource,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "attSource",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.attSource",
                                        },
                                      },
                                      _vm._l(
                                        _vm.attachSourceOption,
                                        function (dict) {
                                          return _c("el-option", {
                                            key: dict.dictValue,
                                            attrs: {
                                              label: dict.dictLabel,
                                              value: dict.dictValue,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "createByName",
                              label: "上传人",
                              width: "80px",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "createTime",
                              label: "上传时间",
                              width: "160px",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "80",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDownload(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("下载")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(
                                              scope.$index,
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: {
                "margin-top": "-15px",
                "margin-left": "-20px",
                "margin-right": "-20px",
              },
            },
            [_c("el-divider")],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: {
                height: "50px",
                "margin-top": "-10px",
                "margin-left": "86%",
              },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.closeDialog } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    disabled: _vm.submitting,
                  },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("wlDialogRowDetail", {
        ref: "AttachRowDialog",
        staticStyle: { "align-items": "center" },
        attrs: {
          open: _vm.rowDetailsVisible,
          "row-item": _vm.rowItem,
          "row-details-form": _vm.rowDetailsForm,
          "row-no": _vm.rowNo,
          "row-rules": _vm.rowRules,
          title: "附件明细",
          "open-type": "edit",
        },
        on: {
          "update:open": function ($event) {
            _vm.rowDetailsVisible = $event
          },
          updateRowDetail: _vm.onRowOk,
          closeDialog: _vm.closeRowDetailsDialog,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }